import { useEffect } from "react";
import { useApi } from "../../../hooks/useApi";
import { useRedux } from "../../../hooks/useRedux";
import UtilsCommonsService from "../../../services/utilsCommons.service";

const { gerUtilsDinamicSurvey } = new UtilsCommonsService();

export function useDinamicSurvey() {
  const {
    data: {
      clientPersist: { uuid },
    },
  } = useRedux();

  const {
    data: dataDinamicSurvey = [],
    error: errorDinamicSurvey,
    execute: execGetDinamicSurvey,
    isLoading: isLoadingDinamicSurvey,
  } = useApi<any,
    { processId: string }
  >(gerUtilsDinamicSurvey);

  useEffect(() => {
    return () => {
      execGetDinamicSurvey({ processId: uuid });
    };
  }, []);

  return {
    dataDinamicSurvey,
    isLoadingDinamicSurvey,
    errorDinamicSurvey,
  };
}
